import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { CookieService } from 'ngx-cookie-service';
import { Observable, map, tap } from 'rxjs';
import { TuwaiqConfig } from 'src/app/core/constants/tuwaiq.config';
import { USER_ROLE } from 'src/app/core/constants/user-role.enum';
import { FilterDetails } from 'src/app/core/models/filter-details.model';
import { LoggedInUserService } from 'src/app/core/services/logged-in-user.service';
import { RequestViewService } from 'src/app/core/services/request-view.service';
import { TranslateService } from 'src/app/core/translate';
import { SectionsService } from './../../services/sections.service';

@Component({
    selector: 'app-select-section',
    templateUrl: './select-section.component.html',
    styleUrls: ['./select-section.component.scss']
})
export class SelectSectionComponent implements OnInit {
    public defaultValue: number = 0;
    @Input() userPath = 'admin';
    public list: Observable<{ name: string; value: number }[]>;

    USER_ROLE = USER_ROLE;
    userRole: USER_ROLE;

    @Output() selectChange: EventEmitter<number> = new EventEmitter<number>();
    constructor(
        private cookies: CookieService,
        private readonly sectionsService: SectionsService,
        private readonly requestViewService: RequestViewService,
        public readonly loggedInUserService: LoggedInUserService,
        private readonly translateService: TranslateService,
        private readonly cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.userRole = this.getUserRole();
        this.list = this.sectionsService.getAll(this.userPath).pipe(
            map(sections => sections.map(sec => ({ name: sec.name, value: sec.id }))),
            tap(() => (this.defaultValue = Number(this.loggedInUserService.viewAsSection())))
        );
        this.translateService.currentLang$.pipe(
            map(lang => {
                console.log(lang);
                this.cdr.detectChanges();
            })
        );
    }

    private getUserRole(): USER_ROLE {
        return this.loggedInUserService.getUserRole();
    }

    public selectSection(section: MatSelectChange): void {
        const id = JSON.stringify(section.value);
        if (section.value) {
            this.cookies.set('VIEW_AS', id, null, '/');
            this.list.pipe(map(array => array.find(item => item.value === parseInt(id)))).subscribe(foundItem => {
                console.log(foundItem);
                this.cookies.set('ClickedSectionFilterPublic', foundItem.name, null, '/');
            });
        } else {
            this.loggedInUserService.clearViewAs();
        }
        this.setSectionFilter(id);
    }

    private setSectionFilter(sectionId: string): void {
        const filterDetailsList = [];
        const sectionIdFilter: FilterDetails = {
            key: TuwaiqConfig.REQUEST_QUERY_PARAMS.SECTION_FILTER,
            value: sectionId,
            removeFilter: Number(sectionId) ? false : true
        };
        filterDetailsList.push(sectionIdFilter);
        this.requestViewService.filterRequestList.next(filterDetailsList);
        this.requestViewService.updateCount.next(true);
        this.sectionsService.setSectionChanging(sectionId);
    }
}
